import { Button } from "@mui/material";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { TbPlus } from "react-icons/tb";

import { usePlanActions, usePlanSearchItemId, usePlanShowCreatePassengerDialog } from "@/stores/use-plan-table";

function PlanPanelCreateButton({
    totals,
}: {
    totals: {
        row: number;
        cell: number;
    };
}) {
    const showCreatePassengerDialog = usePlanShowCreatePassengerDialog();
    const { updatShowCreatePassengerDialog } = usePlanActions();
    const searchItemId = usePlanSearchItemId();
    const { t } = useTranslation();
    const handleClick = useCallback(() => {
        updatShowCreatePassengerDialog(true);
    }, [updatShowCreatePassengerDialog]);

    return (
        <Button
            disabled={showCreatePassengerDialog || !!totals.row || !!searchItemId}
            className=" grow-0 shrink-0"
            variant="contained"
            onClick={handleClick}
            startIcon={<TbPlus />}
        >
            {t("buttons.newPassenger")}
        </Button>
    );
}

export default PlanPanelCreateButton;
